import React, { memo } from 'react';
import icons from '@icons';

import { Picture } from '@ui';
import './index.scss';

const {
  heart: { red: heartFilledRed },
  bookmark: { red: bookmarkFilledRed }
} = icons.Fill;
const {
  heart: { black: heartOutlinedBlack },
  bookmark: { black: bookmarkOutlinedBlack }
} = icons.Outline;

const Controls = ({
  isDesktop,
  isFavorite,
  prepareToAddToFavourites,
  isShowPostponed,
  changePostponedStatus,
  isPostponed
}) => {
  return (
    <div className='controls'>
      <div className='control control--fav'>
        <Picture
          onClick={e => prepareToAddToFavourites({ isFavorite, e })}
          height={isDesktop ? '26' : '20'}
          icon={isFavorite ? heartFilledRed.x2 : heartOutlinedBlack.x2}
          iconHover={heartFilledRed.x2}
        />
      </div>
      {isShowPostponed && (
        <div className='control control--fav'>
          <Picture
            onClick={e => changePostponedStatus(e)}
            height={isDesktop ? '26' : '20'}
            icon={isPostponed ? bookmarkFilledRed.x2 : bookmarkOutlinedBlack.x2}
            iconHover={bookmarkFilledRed.x2}
          />
        </div>
      )}
    </div>
  );
};

export default memo(Controls);
